import {BaseService} from './Core/BaseService';
import {BaseSearchableService} from "./Core/BaseSearchableService";

class ContextNodeActivityService extends BaseSearchableService {
    get Url() { return super.Url + "/contextNodeActivities"; }

    Get(contextNodeId, lastActivityId = undefined) {
        return this.SendRequest(BaseService.GET, { contextNodeId, lastActivityId }, null);
    }
}

export const service = new ContextNodeActivityService();

